import type {
  ListSelection,
  TreeSelection,
} from '../../../filters/types/filters';
import type {
  BoxDataSet,
  SingleDataPoint,
  TimeseriesData,
} from '../../DataProvider/types';

export type ParameterSelection = TreeSelection | ListSelection;

type DataPoint = TimeseriesData | SingleDataPoint;
export const isParameterSelectionEqualToDataPoint = (
  parameter: ParameterSelection,
  dataPoint: DataPoint
) => {
  return parameter.id === dataPoint.id || parameter.name === dataPoint.dim;
};

export const isParameterSelectionEqualToBoxDataSet = (
  parameter: ParameterSelection,
  boxDataSet: BoxDataSet
) => {
  return parameter.id === boxDataSet.id || parameter.name === boxDataSet.dim;
};
